import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from '@/locales/en-US'
import zhTW from '@/locales/zh-TW'
import jaJP from '@/locales/ja-JP'

Vue.use(VueI18n)

export const languages = [
	{ text: 'English', value: 'en' },
	{ text: '繁體中文', value: 'zh' },
	{ text: '日本語', value: 'ja' }
]

const messages = {
	'en': enUS,
	'zh': zhTW,
	'ja': jaJP
}

// const savedLocale = localStorage.getItem('locale') || 'en'

function getSubdomainPrefix(): string {
	let currentUrl = location.href
	let baseDomain = process.env.VUE_APP_BASE_DOMAIN || ''

	if (currentUrl.includes('localhost')) {
		currentUrl = 'https://ifa.ws.dev.namecard.ai/match'
		baseDomain = '.ws.dev.namecard.ai'
	}

	const baseDomainIndex = currentUrl.indexOf(baseDomain)
	const baseLine = currentUrl.indexOf('//')

	if (baseDomainIndex > -1 && baseLine > -1) {
		return currentUrl.substring(baseLine + 2, baseDomainIndex)
	}
	return ''
}

function detectLocale() {
	const savedLocale = localStorage.getItem('locale')
	if (savedLocale) return savedLocale

	// track_id = 20 (ifa subdomain) 強制使用英文
	if (getSubdomainPrefix() === 'ifa') {
		console.log('ifa subdomain detected, force en')
		localStorage.setItem('locale', 'en')
		return 'en'
	}

	const userLang = navigator.language
	if (userLang.toLowerCase().startsWith('zh')) {
		localStorage.setItem('locale', 'zh')
		return 'zh'
	} else if (userLang.toLowerCase().startsWith('ja')) {
		localStorage.setItem('locale', 'ja')
		return 'ja'
	} else {
		localStorage.setItem('locale', 'en')
		return 'en'
	}
}

const i18n = new VueI18n({
	// locale: savedLocale,
	locale: detectLocale(),
	fallbackLocale: 'en',
	messages
})

export default i18n